import React, { PropsWithChildren, useEffect } from 'react';

export default ({ children }: PropsWithChildren) => {
  useEffect(() => {
    if (children) {
      document.title = children?.toString();
    }
  }, [children]);
  return <></>;
};